import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { toSplitGroup, type RawSplitGroup } from "../lib/split-vm";

export function useSplit(saleOrderId: string) {
  return useQuery({
    queryKey: ["split", saleOrderId],
    enabled: !!saleOrderId,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/split-orders/{sale_order_id}", {
        params: { path: { sale_order_id: saleOrderId } },
      });
      if (error) throw error;
      // BE may return a thinner projection than SplitDetail renders; toSplitGroup
      // defaults the nested arrays (labels/trace/items) so it can't crash.
      return toSplitGroup(data as unknown as RawSplitGroup);
    },
  });
}
